// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__32JPJ","title":"Images90_title__15Vhx","images":"Images90_images__1Ar5b"};